import { getPathLocale } from '@/i18n/utils/get-path-locale';
// eslint-disable-next-line no-restricted-imports
import { usePathname } from 'next/navigation';

export function useCleanPathname() {
  const pathname = usePathname();
  const locale = getPathLocale(pathname);

  // If we found a locale, remove it from the path
  if (locale) {
    return pathname.replace(`/${locale}`, '') || '/';
  }

  return pathname;
}
